import {
	Component, Input, OnInit, OnChanges, SimpleChanges, OnDestroy,
	ChangeDetectorRef
} from '@angular/core';
import { Observable, Subject, Subscription } from 'rxjs/Rx';
import { MessageService } from 'base';
import { NetFacadeService } from 'netview';
import { ShareDto, ShareTypes, ShareAccessTypes } from 'UvExplorerServer.Dtos.TS/Shares';
import { NetViewDto } from 'UvExplorerServer.Dtos.TS/NetViews';


@Component({
	selector: 'share-target',
	templateUrl: './share-target.component.html',
	styleUrls: ['./share-target.component.scss']
})
export class ShareTargetComponent implements OnInit, OnChanges, OnDestroy {

	// Optional
	@Input()
	public sharedItemGuid: string;

	public entries: any[];

	private sharesLoadedSub: Subscription;
	private sharesChangedSub: Subscription;

	constructor(private messageService: MessageService, private netFacadeService: NetFacadeService) {

		this.sharedItemGuid = "";

		this.rebuildEntries();

		this.sharesLoadedSub = this.netFacadeService.onSharesLoaded.subscribe(() => {
			this.rebuildEntries();
		});
		this.sharesChangedSub = this.netFacadeService.onSharesChanged.subscribe(() => {
			this.rebuildEntries();
		});
	}

	public ngOnInit(): void {
		return;
	}

	public ngOnChanges(changes: SimpleChanges): void {
		this.rebuildEntries();
	}

	public ngOnDestroy(): void {
		if (this.sharesLoadedSub) {
			this.sharesLoadedSub.unsubscribe();
			this.sharesLoadedSub = undefined;
		}
		if (this.sharesChangedSub) {
			this.sharesChangedSub.unsubscribe();
			this.sharesChangedSub = undefined;
		}
	}

	public get hasSharedItemGuid(): boolean {
		return !!this.sharedItemGuid;
	}

	public get hasEntries(): boolean {
		return (!!this.entries && this.entries.length > 0);
	}

	private capitalize(s: string): string {
		if (typeof s !== 'string') return ''
		return s.charAt(0).toUpperCase() + s.slice(1)
	}

	private shareTargetName(share: ShareDto): string {
		if (share.HasTargetUserGuid) {
			return "Me";
		}
		else {
			return share.TargetGroupName;
		}
	}

	private shareTargetType(share: ShareDto): string {
		return (share.HasTargetUserGuid ? "User" : "Group");
	}

	private rebuildEntries(): void {
		this.entries = [];
		this.netFacadeService.targetShares.forEach((share: ShareDto) => {
			if (!this.hasSharedItemGuid || this.sharedItemGuid == share.SharedItemGuid) {
				let network: NetViewDto = this.netFacadeService.getTargetNetworkByGuid(share.SharedItemGuid);
				if (network) {
					this.entries.push({
						networkName: network.Name,
						sourceUserName: share.SourceUserName,
						shareTargetName: this.shareTargetName(share),
						shareTargetType: this.shareTargetType(share),
						accessType: this.capitalize(share.AccessType),
						tag: { share: share, network: network },
					});
				}
				else {
					console.error("Could not find share network: " + share.SharedItemGuid);
				}
			}
		});
	}

	public deleteShare(share: ShareDto): void {
		this.netFacadeService.deleteTargetShare(share.Guid).subscribe(
			(result: boolean) => {
				this.rebuildEntries();
				this.messageService.displayInfoMessage("Share was deleted");
			},
			(error) => {
				this.messageService.displayErrorMessage("Could not delete share");
			});
	}

}
